import { memo, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Avatar, Typography, Card, CardContent, Grid, Divider, Stack, useTheme, Tooltip } from "@mui/material";
import welcomeImage from "../../../Images/profile/user-1.jpg";
import welcomeImage2 from "../../../Images/backgrounds/welcome-bg.svg";
import { useSubscriptionCall } from "../../../hooks/auth";
import ProfileImageModal from "../../Account-setting/modal/ProfileImageModal";
function WelcomeCard() {
  const theme = useTheme();
  const { name, imageUrl } = useSelector(state => state.reducer.userData) || {};
  const { data } = useSubscriptionCall();
  const [profileImageOpen, setProfileImageOpen] = useState(false);
  const handleProfileImage = () => {
    setProfileImageOpen(!profileImageOpen);
  };
  return (
    <Card elevation={0} sx={{ backgroundColor: theme.palette.primary.light, py: 0, height: "100%" }}>
      <CardContent sx={{ py: 4, px: 2 }}>
        <Grid container justifyContent="space-between">
          <Grid item sm={6} display="flex" alignItems="center">
            <Box>
              <Box
                gap="16px"
                sx={{
                  display: {
                    xs: "block",
                    sm: "flex",
                  },
                  alignItems: "center",
                }}
              >
                <Tooltip title="Click to Expand" placement="top">
                  <Avatar
                    src={imageUrl || welcomeImage}
                    alt="img"
                    onClick={handleProfileImage}
                    sx={{ width: 60, height: 60, border: `1.5px solid ${theme.palette.primary.main}`, cursor: "pointer" }}
                  />
                </Tooltip>
                <ProfileImageModal profileImage={imageUrl || welcomeImage} open={profileImageOpen} handleClose={handleProfileImage} />
                <Box>
                  <Typography variant="h5" sx={{ whiteSpace: { xs: "wrap", sm: "nowrap" }, fontSize: "28px", fontWeight: "700", mb: "12px" }}>
                    Welcome
                  </Typography>
                  <Typography component="span" sx={{ fontSize: "18px", fontWeight: "500" }}>
                    {data?.userCreate?.name ?? name}
                  </Typography>
                </Box>
              </Box>
              <Stack spacing={2} direction="row" divider={<Divider orientation="vertical" flexItem />}></Stack>
            </Box>
          </Grid>
          <Grid item sm={6}>
            <Box mb="-51px" textAlign="right">
              <Typography component="img" src={welcomeImage2} alt="img" width="250px" />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default memo(WelcomeCard);
